/**
 * Shared storage configuration utilities
 * 
 * Uses centralized environment configuration instead of hostname detection.
 */

import { config } from '../config/environment';

const SHARED_SAS_TOKEN = process.env.REACT_APP_SHARED_SAS_TOKEN || '';

const CONTAINER_NAME = 'public-assets';

/**
 * Get the shared storage account name from centralized config.
 */
export function getSharedStorageAccount(): string {
  return config.storage.sharedAccount;
}

/**
 * Get the base URL for the shared storage account's public assets container.
 */
export function getPublicAssetsBaseUrl(): string {
  const storageAccount = getSharedStorageAccount();
  return `https://${storageAccount}.blob.core.windows.net/${CONTAINER_NAME}`;
}

/**
 * Get a full URL for a public asset with SAS token.
 * @param assetPath - Path relative to the public-assets container (e.g., 'templates/file.xlsx')
 * @param cacheBuster - Optional cache buster string to append
 */
export function getPublicAssetUrl(assetPath: string, cacheBuster?: string): string {
  const baseUrl = getPublicAssetsBaseUrl();
  const cleanPath = assetPath.replace(/^\//, ''); // Remove leading slash if present
  
  if (cacheBuster) {
    return `${baseUrl}/${cleanPath}?${cacheBuster}&${SHARED_SAS_TOKEN}`;
  }
  return `${baseUrl}/${cleanPath}?${SHARED_SAS_TOKEN}`;
}

/**
 * Get the SAS token for public assets.
 * Exposed for cases where URL construction needs to be customized.
 */
export function getSharedSasToken(): string {
  return SHARED_SAS_TOKEN;
}

/**
 * Get the container name for public assets.
 */
export function getPublicAssetsContainerName(): string {
  return CONTAINER_NAME;
}
